! function(t, e) {
    t.init = function() {
        e(document).on("click", "[accordion-trigger]", function() {
            e(this).toggleClass("is-active"), e(this).siblings("[accordion-content]").slideToggle(300)
        })
    }
}(window.Accordions = window.Accordions || {}, jQuery),
function(t, e) {
    var o = {};
    t.init = function() {
        var t;
        o.select = e(".shop-by.js-style-select"), o.select.on("change", function(t) {
            var o = e(t.currentTarget),
                i = o.closest(".js-quick-add"),
                n = i.closest(".collection-grid-item"),
                a = e(".product-item--price [data-price]"),
                r = e(".product-item--price [data-compare-price]"),
                s = e("[data-price-per-unit]"),
                c = i.find(".quick-cart.button"),
                l = o.find(":selected").data("price"),
                d = o.find(":selected").data("compare-price"),
                u = o.find(":selected").data("variant-price-per-unit");
            console.log(u), n.find(a).text("$" + l), n.find(r).text("$" + d), n.find(s).text(u), c.attr("data-cart-add", o.val())
        }), t = '<?xml version="1.0" encoding="utf-8"?><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="15" height="15" viewBox="0 0 55 56"><path d="M44.557 19.495c-2.069 2.069-16.554 16.036-16.554 16.036s-15.002-13.967-17.071-16.036-3.104 3.104-3.104 3.104l20.175 18.623 19.658-18.623c0 0-1.035-5.173-3.104-3.104z" fill="#000000"></path></svg>', console.log("loaded selectize"), e(".shop-by.js-style-select").selectric({
            arrowButtonMarkup: '<b class="button">' + t + "</b>"
        }), e(".sort-by.js-style-select").selectric({
            arrowButtonMarkup: '<b class="button">' + t + "</b>"
        })
    }
}(window.CollectionGrid = window.CollectionGrid || {}, jQuery),
function(t, e) {
    t.init = function() {
        e(document).on("click", ".recurring_div label", function() {
            e(".cart-add-block .quantity-selector").hide(), e(".beans-product").css({
                "margin-top": "10px"
            })
        }), e(document).on("click", ".one_time_div label", function() {
            e(".cart-add-block .quantity-selector").show(), e(".beans-product").css({
                "margin-top": "30px"
            })
        }), e(document).on("change", "#productSelect", function() {
            var t = e(this).val();
            e("#addToCart").attr("data-variant-id", t)
        }), e(".add-on-checkbox").on("change", function() {
            var t = e(this).is(":checked"),
                o = e(this).val(),
                i = e("#addToCart").attr("data-addon-variants");
            if (t) i = void 0 === i ? o : i + " " + o, e("#addToCart").attr("data-addon-variants", i);
            else if (void 0 !== i) {
                var n = (i = i.split(" ")).indexOf(o);
                i.splice(n, 1), "" != (i = i.join(" ")) ? e("#addToCart").attr("data-addon-variants", i) : e("#addToCart").removeAttr("data-addon-variants")
            }
        })
    }
}(window.CustomProduct = window.CustomProduct || {}, jQuery);
var _slicedToArray = function() {
    return function(t, e) {
        if (Array.isArray(t)) return t;
        if (Symbol.iterator in Object(t)) return function(t, e) {
            var o = [],
                i = !0,
                n = !1,
                a = void 0;
            try {
                for (var r, s = t[Symbol.iterator](); !(i = (r = s.next()).done) && (o.push(r.value), !e || o.length !== e); i = !0);
            } catch (t) {
                n = !0, a = t
            } finally {
                try {
                    !i && s.return && s.return()
                } finally {
                    if (n) throw a
                }
            }
            return o
        }(t, e);
        throw new TypeError("Invalid attempt to destructure non-iterable instance")
    }
}();

function _toConsumableArray(t) {
    if (Array.isArray(t)) {
        for (var e = 0, o = Array(t.length); e < t.length; e++) o[e] = t[e];
        return o
    }
    return Array.from(t)
}! function(t, e) {
    var o = {},
        i = function() {
            e(window).innerWidth() > 768 ? e("[toggle-expand]").each(function(t, o) {
                if (0 == t) e(o).closest(".advanced-filter").show(), e(o).find(".toggle-plus-minus").text("--");
                else {
                    var i = setInterval(function() {
                        e(".advanced-filters .advanced-filter a").length > 0 && (clearInterval(i), e(".advanced-filters .advanced-filter a").each(function(t, o) {
                            e(o).hasClass("mixitup-control-active") && (e(o).closest(".sort-by-grid-item").find("[toggle-expand] .toggle-plus-minus").text("--"), e(o).closest(".advanced-filters").show())
                        }))
                    }, 400);
                    e(o).next().hide()
                }
            }) : (e("[toggle-expand]").next().show(), e("[toggle-expand]").find(".toggle-plus-minus").text("--"))
        };
    var n = function() {
        window.$mixer = mixitup(".mixitup-container", {
                multifilter: {
                    enable: !0
                },
                load: {},
                callbacks: {
                    onMixStart: function(t, o) {
                        e(".advanced-filter a").hasClass("mixitup-control-active") ? e(".is-active.active-menu [data-clear-filter]").removeClass("hidden") : e(".is-active.active-menu [data-clear-filter]").addClass("hidden")
                    },
                    onMixEnd: function(t) {
                        var o;
                        0 === t.totalMatching ? e(".mixitup-no-match").fadeIn() : e(".mixitup-no-match").fadeOut(), 0 === t.totalHide ? history.pushState("", document.title, window.location.pathname + window.location.search) : (o = e.unique(e("[data-filter-group]").map(function(t, o) {
                            return e(o).attr("data-filter-group")
                        }).get()).reduce(function(t, e) {
                            var o = $mixer.getFilterGroupSelectors(e);
                            return o.length ? [].concat(_toConsumableArray(t), [e + "=" + o.join(",")]) : [].concat(_toConsumableArray(t))
                        }, []).join("&"), window.location.hash = o)
                    }
                }
            }),
            function(t) {
                window.location.hash.slice(1).split("&").filter(function(t) {
                    return t
                }).forEach(function(e) {
                    var o = e.split("=");
                    if (2 === o.length) {
                        var i = _slicedToArray(o, 2),
                            n = i[0],
                            a = i[1];
                        t.setFilterGroupSelectors(n, a.split(","))
                    }
                }), t.parseFilterGroups()
            }($mixer)
    };
    var a = function() {
        e("[toggle-expand]").on("click", function(t) {
            ! function(t) {
                var o = e(t.currentTarget).find(".toggle-plus-minus"),
                    i = e(t.currentTarget).next();
                "+" == o.text() ? (o.text("--"), i.slideDown()) : (o.text("+"), i.slideUp())
            }(t)
        }), window.onbeforeunload = function() {
            e(".js-sort-by").prop("selectedIndex", 0)
        }, e(".js-sort-by").on("change", function() {
            $mixer.sort(this.value)
        }), e(".toggle-filters").on("click", function() {
            e("header").toggleClass("fixed-header"), e(".advanced-filter a").hasClass("mixitup-control-active") ? e(".is-active.active-menu [data-clear-filter]").removeClass("hidden") : e(".is-active.active-menu [data-clear-filter]").addClass("hidden")
        }), e("[data-clear-filter]").on("click", function() {
            window.location.hash.slice(1).split("&").filter(function(t) {
                return t
            }).forEach(function(t) {
                var e = t.split("=");
                $mixer.setFilterGroupSelectors(e[0], [])
            }), $mixer.filter("all")
        })
    };
    t.init = function() {
        o.plusMinus = e(".toggle-plus-minus"), o.toggleExpand = e("[toggle-expand]"), a(), i(), n()
    }
}(window.Filtering = window.Filtering || {}, jQuery),
function(t, e) {
    var o = {},
        i = function() {
            e(".toggle-filters").on("click", function(t) {
                var o, i, n, a, r, s, c;
                console.log("clicked"), e(".section-header").toggleClass("section-fixed-header"), e(".section-header").hasClass("section-fixed-header") && (o = ".section-fixed-header", i = ".sidebar-sort-by", n = ".sort-filters", a = e(window).innerHeight(), r = e(".header.BVA").innerHeight(), s = r + e(o).outerHeight() - 10, c = a - s, e(o).css("top", r), e(i).css({
                    top: s,
                    height: c
                }), e(n).css({
                    top: s,
                    height: c
                }))
            }), o.toggleFilter.on("click", function() {
                e("#toggleFilters").hasClass("is-active") ? e("#toggleFilters.is-active").attr("disabled", !1) : e("#toggleFilters").attr("disabled", !0)
            }), o.closeToggleFilter.on("click", function() {
                o.toggleFilter.attr("disabled", !1)
            })
        };
    t.init = function() {
        o.sectionHeader = e(".section-header"), o.bodyHeader = e(".header.BVA"), o.toggleFilter = e("#toggleFilters"), o.closeToggleFilter = e("[toggle-filters-close]"), i()
    }
}(window.FixedHeader = window.FixedHeader || {}, jQuery),
function(t, e) {
    t.init = function() {
        e(".footer").on("click", ".menu-title", function() {
            var t = e(this).siblings("ul");
            window.innerWidth < 868 && (t.hasClass("active") ? (t.removeClass("active"), e(this).removeClass("active")) : (t.addClass("active"), e(this).addClass("active")))
        })
    }
}(window.Footer = window.Footer || {}, jQuery),
function(t, e) {
    "use strict";
    t.debounce = function(t, e, o) {
        var i = void 0;
        return function() {
            var n = this,
                a = arguments,
                r = o && !i;
            clearTimeout(i), i = setTimeout(function() {
                i = null, o || t.apply(n, a)
            }, e), r && t.apply(n, a)
        }
    }
}(window.Helpers = window.Helpers || {}, jQuery),
function(t, e) {
    var o = {
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: !1,
        arrows: !0,
        prevArrow: '<button class="slick-arrow slick-prev"><i class="fa fa-arrow-left"></i></button>',
        nextArrow: '<button class="slick-arrow slick-next"><i class="fa fa-arrow-right"></i></button>',
        responsive: [{
            breakpoint: 992,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1
            }
        }, {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        }, {
            breakpoint: 540,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                adaptiveHeight: !0
            }
        }]
    };
    t.init = function() {
        e(document).on("cart.requestComplete", function(t, o) {
            e(".cart-block p > span").html(o.item_count);
            var i = "$ " + (o.total_price / 100).toFixed(2),
                n = e(".coll-mobile-add-cta .quick-cart.quick-cart-clicked").html();
            e(".cart-block .cart-price").html(i), e("[data-active]").text("Added!"), e("[data-active]").css("text-align", "center"), console.log(n), setTimeout(function() {
                e(".product-quick-add [data-active]").html("Add To Cart").removeAttr("data-active"), e(".coll-mobile-add-cta [data-active]").html(n).removeAttr("data-active")
            }, 1500)
        }), e(".quick-cart").on("click", function() {
            e(this).attr("data-active", ""), e(this).addClass("quick-cart-clicked"), setTimeout(function() {
                e(".quick-cart").removeClass("quick-cart-clicked")
            }, 2e3)
        }), e(".bestsellers").on("click", ".quick-cart", function() {
            e(this).text("Adding...")
        }), e(".yotpo-reviews-carousel").on("DOMNodeInserted", function(t) {
            var i = e(t.target).attr("class").split(" ");
            e.each(i, function(t, i) {
                if ("carousel-display-wrapper" == i) return setTimeout(function() {
                    e(".yotpo-carousel .y-slider-container").appendTo(".reviews-replacer"), e(".template-index .standard-layout.single-carousel.review, .template-page .standard-layout.single-carousel.review").wrap('<div class="review-wrap"></div>'), e(".yotpo-reviews-carousel").addClass("active"), e(".reviews-slider .yotpo-carousel .y-slider-container").slick(o), e(".reviews-slider .y-slider-container").slick(o)
                }, 0), !1
            }), e(".carousel-read-more").addClass("read-more"), e(".read-more").click(function() {
                var t = e(".yotpo-reviews-carousel .tool-tip-content").text();
                e(this).closest(".carousel-review-body").text(t)
            })
        })
    }
}(window.HomePage = window.HomePage || {}, jQuery),
function(t, e) {
    "use strict";
    var o = {},
        i = '<button type="button" class="slick-prev"><svg class="icon icon--arrow"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#arrow-circle-icon"></use></svg></button>',
        n = '<button type="button" class="slick-next"><svg class="icon icon--arrow"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#arrow-circle-icon"></use></svg></button>',
        a = (window.innerWidth, {
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: !0,
            nextArrow: n,
            prevArrow: i,
            responsive: [{
                breakpoint: 992,
                settings: {
                    arrows: !1,
                    slidesToShow: 2,
                    centerMode: !0,
                    centerPadding: "60px"
                }
            }, {
                breakpoint: 600,
                settings: {
                    arrows: !1,
                    slidesToShow: 1,
                    centerMode: !0,
                    centerPadding: "40px"
                }
            }, {
                breakpoint: 360,
                settings: {
                    arrows: !1,
                    slidesToShow: 1,
                    centerMode: !0,
                    centerPadding: "30px"
                }
            }]
        }),
        r = {
            centerMode: !0,
            centerPadding: "173px",
            dots: !1,
            infinite: !0,
            nextArrow: n,
            prevArrow: i,
            slidesToShow: 3,
            touchMove: !1,
            responsive: [{
                breakpoint: 1240,
                settings: {
                    centerMode: !0,
                    centerPadding: "300px",
                    slidesToShow: 1
                }
            }, {
                breakpoint: 1024,
                settings: {
                    centerMode: !0,
                    centerPadding: "150px",
                    slidesToShow: 1,
                    touchMove: !0
                }
            }, {
                breakpoint: 992,
                settings: {
                    arrows: !1,
                    centerMode: !0,
                    centerPadding: "150px",
                    slidesToShow: 1,
                    touchMove: !0
                }
            }, {
                breakpoint: 580,
                settings: {
                    arrows: !1,
                    centerMode: !0,
                    centerPadding: "40px",
                    slidesToShow: 1,
                    touchMove: !0
                }
            }, {
                breakpoint: 360,
                settings: {
                    arrows: !1,
                    centerMode: !0,
                    centerPadding: "20px",
                    slidesToShow: 1,
                    touchMove: !0
                }
            }]
        },
        s = {
            arrows: !0,
            infinite: !0,
            nextArrow: n,
            prevArrow: i,
            slidesToShow: 4,
            touchMove: !1,
            responsive: [{
                breakpoint: 1240,
                settings: {
                    slidesToShow: 3
                }
            }, {
                breakpoint: 900,
                settings: {
                    arrows: !1,
                    slidesToShow: 2
                }
            }, {
                breakpoint: 768,
                settings: {
                    arrows: !1,
                    centerMode: !0,
                    slidesToShow: 1,
                    touchMove: !0,
                    variableWidth: !0
                }
            }]
        },
        c = function(t) {
            e(t).on("setPosition", function(t) {
                var o = e(t.currentTarget);
                o.find(".slick-slide").height("auto");
                var i = o.find(".slick-track"),
                    n = e(i).height();
                o.find(".slick-slide").css("height", n + "px")
            })
        },
        l = function() {
            var t = o.reviewAnimation[0].getBoundingClientRect();
            if (t.top >= 0 && t.bottom <= .66 * window.innerHeight) {
                if (o.reviewAnimation.hasClass("animate")) return;
                o.reviewAnimation.addClass("animate")
            }
        };
    t.init = function() {
        o.reviewCards = e(".js-review-cards"), o.reviewAnimation = e(".js-review-animation"), o.collectionTiles = e(".js-collection-tiles"), o.imageGallery = e(".js-image-gallery"), o.productCarousel = e(".js-product-carousel"), o.reviewCards.slick(r), o.collectionTiles.slick(a), o.productCarousel.slick(s), c(o.reviewCards), c(o.imageGallery), c(o.productCarousel), e(window).on("scroll", l)
    }
}(window.HomePageComponents = window.HomePageComponents || {}, jQuery),
function(t, e) {
    var o = e("#cd-sidecart"),
        i = function() {
            e.get("/cart?view=contents", function(t) {
                e("[cart-item-count]").html(CartJS.cart.item_count).attr("cart-item-count", CartJS.cart.item_count), e("[data-cart-entry-point]").empty().html(t), o.addClass("speed-in"), e(".sidecart-overlay").addClass("sidecart-active")
                e(document).trigger('CART_CONTENT_UPDATE')
            })
        },
        n = function(t, o) {
            var i = t,
                n = o;
            CartJS.addItem(i, n, {}, {
                success: function(t, o, i) {
                    e(".inline-cart-upsell-container").fadeOut("fast")
                },
                error: function(t, e, o) {
                    window.alert("Sorry, we're unable to do that.\n" + JSON.parse(t.responseText).description)
                }
            })
        },
        a = function(t, o) {
            var i = e(t).attr("data-id"),
                n = o;
            CartJS.updateItemById(i, n, {}, {
                success: function(o, i, n) {
                    e(t).closest(".inline-cart-flex-row").fadeOut("slow")
                },
                error: function(t, e, o) {
                    window.alert("Sorry, we're unable to do that.\n" + JSON.parse(t.responseText).description)
                }
            })
        },
        r = function(t) {
            t.forEach(function(t, e) {
                CartJS.removeItemById(t)
            })
        },
        s = function() {
            e(document).on("click touchstart", ".upsell--add", function(t) {
                var o = e(t.target).prev(".upsell--num").val();
                o++, e(t.target).prev(".upsell--num").val(o)
            }), e(document).on("click touchstart", ".upsell--minus", function(t) {
                var o = e(t.target).next(".upsell--num").val(); - 1 != --o && e(t.target).next(".upsell--num").val(o)
            }), e(document).on("click", ".upsell-add-to-cart", function(t) {
                var o = e(t.target).prev(".js-inline-cart-input").children(".upsell--num").val(),
                    i = e(t.target).prev(".js-inline-cart-input").children(".upsell--num").attr("data-id");
                0 != o && n(i, o)
            }), e(document).on("click touchstart", ".inlineCart--add", function(t) {
                var o = e(t.target).attr("data-variant-qty");
                o++, a(t.target, o)
            }), e(document).on("click touchstart", ".inlineCart--minus", function(t) {
                var o = e(t.target).attr("data-variant-qty");
                o--, a(t.target, o), r()
            }), e(document).on("keypress", "#inlineCart--num", function(t) {
                if (13 == t.which) {
                    t.preventDefault();
                    var o = e(t.target).val();
                    a(t.target, o)
                }
            }), e(document).on("blur", "#inlineCart--num", function(t) {
                t.preventDefault();
                var o = e(t.target).val();
                a(t.target, o)
            }), e("#addToCart").on("click", function() {
                if (e(this).hasClass("product-disabled")) alert("This product is not available for individual purchase.");
                else {
                    var t = e("#addToCart").attr("data-variant-id"),
                        o = e(".js-qty .js--num").val(),
                        a = e("#addToCart").attr("data-addon-variants");
                    if (void 0 !== a) {
                        var r = {};
                        (a = a.split(" ")).forEach(function(t) {
                            r[t] = 1
                        }), r[t] = o, CartJS.updateItemQuantitiesById(r)
                    } else n(t, o);
                    i()
                }
            }), e("[toggle-cart]").on("click touchstart", function(t) {
                e(".mobile-menu-block").removeClass("active"), e("ul.nav-list.main.flex-row").removeClass("active"), t.preventDefault(), i()
            }), e("#cd-sidecart").on("click touchstart", ".close-cart", function(t) {
                t.preventDefault(), o.removeClass("speed-in"), e(".sidecart-overlay").removeClass("sidecart-active")
            }), e("#cd-sidecart").on("click touchstart", ".js-inline-cart-keep-shopping", function(t) {
                t.preventDefault(), o.removeClass("speed-in"), e(".sidecart-overlay").removeClass("sidecart-active")
            }), e(".mobile-menu-block").on("click touchstart", function() {
                o.removeClass("speed-in"), e(".sidecart-overlay").removeClass("sidecart-active")
            }), e("body").on("click", ".sidecart-active", function() {
                o.removeClass("speed-in"), e(".sidecart-overlay").removeClass("sidecart-active")
            }), e(document).on("click touchstart", ".js-remove-item", function(t) {
                ! function(t) {
                    var o = e(t).attr("data-variant-id"),
                        i = e(t).attr("data-line-number"),
                        n = (CartJS.cart.item_count, []),
                        a = [];
                    for (var s in CartJS.cart.items)
                        if (CartJS.cart.items.hasOwnProperty(s)) {
                            var c = CartJS.cart.items[s];
                            c.product_title.indexOf("24ct") > -1 ? n.push(c.variant_id) : a.push(c.variant_id)
                        } var l = a.length;
                    CartJS.updateItem(i, 0, {}, {
                        success: function(i, s, c) {
                            e(t).closest(".inline-cart-flex-row").fadeOut("slow"), a.indexOf(parseInt(o)) > -1 && 1 == l && r(n)
                        },
                        error: function(t, e, o) {
                            window.alert("Sorry, we're unable to do that.\n" + JSON.parse(t.responseText).description)
                        }
                    })
                }(t.target)
            }), e(document).on("click", "[checkout]", function(t) {
                ! function(t) {
                    for (var e = !1, o = 0; o < CartJS.cart.items.length; o++) {
                        var i = CartJS.cart.items[o];
                        if (null != i.properties && void 0 !== i.properties.group_id && (e = !0), e) {
                            t.preventDefault();
                            var n = CartJS.cart.token,
                                a = "https://recurringcheckout.com/s/iblends/checkout/recurring/" + n + "?shop_url=iblends.myshopify.com",
                                r = document.createElement("form");
                            r.action = a, r.method = "post";
                            var s = document.createElement("input");
                            s.setAttribute("type", "hidden"), s.setAttribute("name", "shopify_cart"), s.setAttribute("value", encodeURIComponent(JSON.stringify(CartJS.cart))), r.appendChild(s);
                            var c = document.createElement("input");
                            c.setAttribute("type", "hidden"), c.setAttribute("name", "csrf_bold_token"), c.setAttribute("value", n), r.appendChild(c), document.getElementsByTagName("body")[0].appendChild(r), r.submit()
                        }
                    }
                }(t)
            }), e(document).on("cart.requestComplete", function(t, e) {
                i()
            })
        };
    t.init = function() {
        s()
    }
}(window.InlineCart = window.InlineCart || {}, jQuery),
function(t, e) {
    e('[data-button="tasting-kit"]');
    var o = e('[data-button="tasting-kit"]'),
        i = e(".modal-overlay"),
        n = e("#business-lp .closer");
    t.init = function() {
        o.click(function(t) {
            if (t.preventDefault(), i.is(":visible")) i.slideUp(500);
            else {
                i.slideDown(500);
                var n = o.offset().top - 5;
                e("html,body").animate({
                    scrollTop: n
                }, 500)
            }
        }), n.click(function() {
            i.slideUp(500)
        }), e(".feedback.successForm").length > 0 && (i.find("h3,p,.directions, #businessFormWrapper").hide(), i.show(), setTimeout(function() {
            i.fadeOut(500)
        }, 5e3)), e(".feedback.errorForm").length > 0 && i.show()
    }
}(window.LandingPage = window.LandingPage || {}, jQuery),
function(t, e) {
    "use strict";
    var o = {};
    t.show = function(t) {
        return window.Overlay.show(), window.Scroll.lock(), o.body.attr("data-active-modal", t), e('[data-modal="' + t + '"]').fadeIn(300)
    }, t.hide = function() {
        return window.Overlay.hide(), window.Scroll.unlock(), o.body.removeAttr("data-active-modal"), o.modal.fadeOut(300)
    };
    t.init = function() {
        o.body = e("body"), o.modal = e("[data-modal]"), o.modalShow = e("[data-modal-show]"), o.modalHide = e("[data-modal-hide]"), o.modalShow.on("click", function(t) {
            t.preventDefault(), window.Modal.show(e(this).attr("data-modal-show"))
        }), o.modalHide.on("click", function(t) {
            t.preventDefault(), window.Modal.hide()
        })
    }
}(window.Modal = window.Modal || {}, jQuery),
function(t, e) {
    var o = "header",
        i = "[toggle-search]",
        n = "[nav-search-input]",
        a = "[toggle-account]",
        r = "[toggle-mobile-nav]",
        s = "[mobile-nav-screen-container]",
        c = "[toggle-mobile-nav-screen]",
        l = "[toggle-mobile-subnav]",
        d = "[mobile-subnav]",
        u = "[single-link-toggler]",
        p = "[subnav__single-links]",
        v = "[footer-nav-toggle]",
        f = function(t) {
            var o = e(t.currentTarget),
                i = o.attr("footer-nav-toggle"),
                n = e('[footer-nav="' + i + '"]');
            o.toggleClass("is-active"), n.slideToggle(250)
        };
    t.accountToggle = function(o) {
        o.preventDefault(), e(o.currentTarget).hasClass("is-active") ? t.accountClose() : t.accountOpen()
    }, t.accountOpen = function() {
        e(o).addClass("account-active"), e(a).addClass("is-active")
    }, t.accountClose = function() {
        e(o).removeClass("account-active"), e(a).removeClass("is-active").trigger("blur")
    }, t.searchToggle = function(o) {
        o.preventDefault(), e(o.currentTarget).hasClass("is-active") ? t.searchClose() : t.searchOpen()
    }, t.searchOpen = function() {
        e(o).addClass("search-active"), e(i).addClass("is-active"), e(n).trigger("focus"), Scroll.lock()
    }, t.searchClose = function() {
        e(o).removeClass("search-active"), e(i).removeClass("is-active").trigger("blur"), Scroll.unlock()
    }, t.mobileNavToggle = function(o) {
        o.preventDefault(), e(o.currentTarget).hasClass("is-active") ? t.mobileNavClose() : t.mobileNavOpen()
    }, t.mobileSingleLinks = function(t) {
        var o = t.currentTarget,
            i = o.getAttribute("nav-sub");
        console.log("GATAZO"), console.log(i), o.getAttribute("class").includes("active-mobile-links") ? (o.classList.remove("active-mobile-links"), e(p).filter('[nav-sub="' + i + '"]').removeClass("nav-mobile__single-active")) : (o.classList.add("active-mobile-links"), e(p).filter('[nav-sub="' + i + '"]').addClass("nav-mobile__single-active"))
    }, t.mobileNavOpen = function() {
        e(o).addClass("mobile-nav-active"), e(r).addClass("is-active"), Scroll.lock()
    }, t.mobileNavClose = function() {
        e(o).removeClass("mobile-nav-active"), e(r).removeClass("is-active"), Scroll.unlock()
    }, t.mobileNavScreenToggle = function(t) {
        t.preventDefault(), e(s).toggleClass("is-extended")
    }, t.mobileSubnavToggle = function(t) {
        t.preventDefault();
        var o = e(t.currentTarget).attr("toggle-mobile-subnav");
        e(d).removeClass("is-active"), e(d).filter('[mobile-subnav="' + o + '"]').addClass("is-active")
    }, t.init = function() {
        e(i).on("click", t.searchToggle), e(a).on("click", t.accountToggle), e(r).on("click", t.mobileNavToggle), e(c).on("click", t.mobileNavScreenToggle), e(l).on("click", t.mobileSubnavToggle), e(u).on("click", t.mobileSingleLinks), e(v).on("click", f)
    }
}(window.Navigation = window.Navigation || {}, jQuery),
function(t, e, o) {
    t.show = function() {
        e(".overlay").addClass("is-active")
    }, t.hide = function() {
        e(".overlay").attr("class", "overlay")
    }, t.init = function() {}
}(window.Overlay = window.Overlay || {}, jQuery),
function(t, e) {
    var o = {},
        i = ["group_id", "frequency_num", "frequency_type", "frequency_type_text", "discounted_price", "_ro_discount_percentage", "_ro_discount_percentage", "_ro_unformatted_price"],
        n = function(t, e) {
            t && (console.log(t), function(t) {
                o.variantOption.text(t.title)
            }(t), function(t) {
                o.price.text(Shopify.formatMoney(t.price)), o.comparePrice.text(Shopify.formatMoney(t.compare_at_price));
                var e = Shopify.product.options.indexOf("Size");
                if (-1 !== e) {
                    var i = t.options[e];
                    if (-1 !== i.indexOf("ct")) {
                        var n = i.replace("ct", "");
                        n = parseInt(n);
                        var a = Math.round(t.price / n) + "¢",
                            r = a + "/pod";
                        o.unitPriceFull.text(r), o.unitPrice.text(a)
                    } else if (-1 !== i.indexOf("oz")) {
                        var n = i.replace("oz", "");
                        n = parseInt(n);
                        var a = Math.round(t.price / n) + "¢",
                            r = a + "/oz";
                        o.unitPriceFull.text(r), o.unitPrice.text(a)
                    }
                }
            }(t), o.addToCart.attr("data-variant-id", t.id), BOLD.recurring_orders.app.ee.emitOut("BOLD_RECURRING_ORDERS_variant_changed"))
        },
        a = function() {
            o.variantSelect.on("change", function() {
                var t = e(this).val();
                e('.single-option-selector[data-option="option1"]').val(t).trigger("change")
            }), o.descToggle.on("click", function() {
                o.desc.toggle()
            }), o.addToCart.on("click", function(t) {
                t.preventDefault();
                var o = e(this).attr("data-variant-id") || !1,
                    n = e(this).attr("data-quantity") || 1,
                    a = function(t, o) {
                        var n = o || {},
                            a = e(t).closest("form");
                        return a.length && (1 == a.find('[name="bold-ro__selector_radio_button"]').length && a.find('[name="bold-ro__selector_radio_button"]').prop("checked", !0).attr("type", "radio"), "1" == a.find('[name="bold-ro__selector_radio_button"]:checked').val() && (n = i.reduce(function(t, e) {
                            var o = a.find('[name="' + e + '"]').val();
                            return t[e] = o, t
                        }, {}))), n
                    }(this) || {};
                o && CartJS.addItem(o, n, a, {
                    success: function(t, e, o) {},
                    error: function(t, e, o) {
                        window.alert("Sorry, we're unable to do that.\n" + JSON.parse(t.responseText).description)
                    }
                })
            }), o.qty.on("change", function() {
                var t = e(this).val();
                o.addToCart.attr("data-quantity", t)
            }), o.qtyAdjust.on("click", function() {
                var t = parseInt(o.qty.val()) + parseInt(e(this).attr("qty-adjust"));
                t < 1 && (t = 1), o.qty.val(t).trigger("change")
            })
        };
    t.init = function() {
        o.addToCart = e("[js-add-cart]"), o.price = e("[product-price]"), o.comparePrice = e("[product-compare-price]"), o.unitPriceFull = e("[current-unit-price]"), o.unitPrice = e("[data-price-per-unit]"), o.qty = e("[qty]"), o.qtyAdjust = e("[qty-adjust]"), o.variantSelect = e("[variant-select]"), o.variantOption = e("[current-option]"), o.desc = e("[product-desc]"), o.descToggle = e("[product-desc-toggle]"), new Shopify.OptionSelectors("product-select-" + Shopify.product.id, {
            product: Shopify.product,
            onVariantSelected: n,
            enableHistoryState: !0
        }), a()
    }
}(window.Product = window.Product || {}, jQuery),
function(t, e) {
    "use strict";
    var o = {},
        i = function() {
            o.hero.addClass("hero--is-new"), Cookies.set("isReturning", !0)
        },
        n = function() {
            0 !== o.hero.length && (Cookies.get("isReturning") ? o.hero.addClass("hero--is-returning") : i())
        };
    t.init = function() {
        o.hero = e(".js-hero-check"), n()
    }
}(window.ReturningCustomer = window.ReturningCustomer || {}, jQuery),
function(t, e) {
    var o = {},
        i = void 0,
        n = void 0,
        a = function() {
            var t = new MutationObserver(function(e) {
                var o = !0,
                    i = !1,
                    n = void 0;
                try {
                    for (var a, r = e[Symbol.iterator](); !(o = (a = r.next()).done); o = !0) {
                        "childList" === a.value.type && (c(), t.disconnect())
                    }
                } catch (t) {
                    i = !0, n = t
                } finally {
                    try {
                        !o && r.return && r.return()
                    } finally {
                        if (i) throw n
                    }
                }
            });
            t.observe(o.reviews.find('.yotpo-reviews[data-host-widget="main_widget"]')[0], {
                childList: !0
            })
        },
        r = function() {
            var t = i.html();
            i.html("(" + t.replace(/ Reviews/g, "") + ")"), i.attr("data-processed", !0)
        },
        s = function() {
            o.reviewsPagination = e(".yotpo-reviews .yotpo-pager .yotpo-page-element");
            var t = o.reviewsPagination.width(),
                i = Math.floor(o.window.width() / t) - 3;
            i > 4 && (i = 4);
            var n = o.reviewsPagination.filter(".yotpo-active").data("page"),
                a = n - Math.floor(i / 2),
                r = n + (i - (4 === i ? 2 : 1));
            n < 3 && (r = i > 3 ? 5 : 4), o.reviewsPagination.each(function(t, o) {
                e(o).data("page") >= a && e(o).data("page") <= r || e(o).hasClass("yotpo-icon") ? e(o).removeClass("yotpo-hidden-mobile") : e(o).addClass("yotpo-hidden-mobile")
            })
        },
        c = function() {
            if (!(e(".yotpo-reviews .yotpo-review .yotpo-main .yotpo-review-stars").length > 0)) {
                var t = e(".yotpo-icon-share"),
                    o = e(".yotpo-icon-chat-bubble"),
                    i = e(".yotpo .yotpo-pager .yotpo-icon");
                t.find(":before").css("content", '""'), t.replaceWith('<svg version="1.1" viewBox="0 0 14 13" xmlns="http://www.w3.org/2000/svg" style="width:15px;height:15px;"><g fill="none" fill-rule="evenodd"><g transform="translate(-22 -2102)" fill="#413732"><g transform="translate(5 1925)"><g transform="translate(17 177)"><path d="m13.813 3.3921l-3.2244-3.2246c-0.1065-0.10638-0.23262-0.15953-0.37806-0.15953-0.066912 0-0.13709 0.014-0.20976 0.041912-0.21841 0.095206-0.32762 0.26035-0.32762 0.49547v1.6124h-1.3436c-0.59335 0-1.1435 0.030794-1.65 0.092353-0.50659 0.061529-0.95306 0.14685-1.3393 0.25612-0.38629 0.10906-0.73479 0.24488-1.0455 0.40724-0.31065 0.16229-0.57515 0.33447-0.79353 0.51644-0.21841 0.18194-0.41009 0.38912-0.57524 0.62144-0.16524 0.23229-0.29671 0.46038-0.39476 0.68432-0.097882 0.224-0.17624 0.47029-0.23506 0.73897-0.058882 0.26874-0.098029 0.52062-0.11762 0.75568-0.019588 0.23512-0.029382 0.48991-0.029382 0.76409 0 0.31362 0.049059 0.65503 0.147 1.0246 0.097971 0.36938 0.20574 0.68844 0.32329 0.95721 0.11753 0.26853 0.25615 0.54715 0.41571 0.83538 0.15953 0.28829 0.27006 0.47991 0.33165 0.57515 0.061559 0.095 0.12044 0.18197 0.17638 0.26029 0.055971 0.072765 0.12874 0.10912 0.21826 0.10912 0.0225 0 0.055941-0.0054706 0.10079-0.016706 0.12874-0.061618 0.18468-0.15662 0.16788-0.28544-0.25188-1.881-0.044706-3.2051 0.62141-3.972 0.64388-0.73335 1.8699-1.1001 3.678-1.1001h1.3437v1.6122c0 0.23532 0.10912 0.40038 0.32753 0.49562 0.072676 0.027971 0.14274 0.041882 0.20976 0.041882 0.15118 0 0.27721-0.053147 0.37806-0.15944l3.2245-3.2246c0.10626-0.10644 0.15953-0.23229 0.15953-0.37785-2.94e-5 -0.14544-0.053294-0.2715-0.15956-0.37771z"/><path d="m11.647 8.0693c-0.10662-0.044971-0.20444-0.022441-0.29391 0.067147-0.14553 0.13435-0.29682 0.23803-0.45353 0.31071-0.10097 0.055941-0.15121 0.13706-0.15121 0.24344v1.7972c0 0.36947-0.13135 0.68553-0.39456 0.94882-0.26309 0.26312-0.57953 0.39468-0.94894 0.39468h-6.9865c-0.36953 0-0.68582-0.13156-0.94894-0.39468-0.26315-0.26329-0.39465-0.57932-0.39465-0.94882v-6.9866c0-0.3695 0.1315-0.68568 0.39465-0.94879 0.26309-0.26315 0.57938-0.39465 0.94894-0.39465h0.9405c0.033559 0 0.078412-0.011265 0.13435-0.033618 0.31353-0.19038 0.68568-0.35838 1.1168-0.50391 0.14556-0.027941 0.21832-0.11747 0.21832-0.26871 0-0.072765-0.026559-0.13562-0.079765-0.18891-0.053206-0.053059-0.11606-0.079647-0.18891-0.079647h-2.1412c-0.66618 0-1.2358 0.23653-1.7089 0.70956-0.473 0.473-0.70953 1.0426-0.70953 1.7088v6.9864c0 0.66621 0.23653 1.2358 0.70956 1.7089 0.47306 0.47306 1.0427 0.70959 1.7089 0.70959h6.9865c0.66609 0 1.2358-0.23653 1.7089-0.70959 0.47309-0.47306 0.70962-1.0426 0.70962-1.7089v-2.1749c-2.94e-5 -0.11194-0.058824-0.19306-0.17647-0.2435z"/></g></g></g></g></svg>'), o.find(":before").css("content", '""'), o.replaceWith('<svg version="1.1" viewBox="0 0 13 11" xmlns="http://www.w3.org/2000/svg" style="width:15px;height:15px;"><g fill="none" fill-rule="evenodd"> <g transform="translate(-95 -2104)" fill="#413732"><g transform="translate(5 1925)"> <path transform="translate(96.325 184.5) scale(-1 1) translate(-96.325 -184.5)" d="m101.8 181.28c-0.5648-0.70407-1.332-1.2602-2.3013-1.6683-0.96932-0.40809-2.0283-0.61218-3.1766-0.61218-0.85655 0-1.6754 0.1205-2.4566 0.36156-0.78119 0.24104-1.4541 0.56684-2.0189 0.97733-0.56485 0.41054-1.0142 0.89863-1.3484 1.4642-0.33418 0.56563-0.50125 1.1588-0.50125 1.7793 0 0.71598 0.21288 1.3869 0.63882 2.0122 0.42594 0.62525 1.0082 1.1504 1.7472 1.5752-0.051824 0.19088-0.11299 0.37232-0.18361 0.54404-0.07059 0.17184-0.13411 0.31284-0.19058 0.42261-0.056522 0.10977-0.13292 0.23156-0.22947 0.3652-0.096403 0.13362-0.16934 0.22794-0.21877 0.28277-0.049376 0.054923-0.13055 0.14576-0.24357 0.27208-0.11287 0.1266-0.18586 0.20888-0.21877 0.24716-0.0047719 0.002232-0.023563 0.023875-0.056497 0.064378-0.032909 0.040502-0.049426 0.060766-0.049426 0.060766l-0.042354 0.064353c-0.023563 0.035888-0.034146 0.058535-0.031821 0.067889 0.0023736 0.009355-0.0023242 0.033381-0.014093 0.071501-0.011794 0.038271-0.010582 0.066936 0.0035109 0.086096v0.007123c0.018915 0.085996 0.060082 0.15516 0.12358 0.20758 0.063494 0.052465 0.13535 0.073983 0.21531 0.064277 0.30597-0.03817 0.57419-0.090435 0.80475-0.1574 1.233-0.31996 2.3155-0.89738 3.2473-1.7329 0.35288 0.038171 0.69408 0.057331 1.0235 0.057331 1.1483 0 2.2072-0.20409 3.1767-0.61236 0.96942-0.40809 1.7365-0.96424 2.3012-1.6682 0.5648-0.70377 0.84716-1.4712 0.84716-2.3018 2.5e-5 -0.8306-0.28231-1.598-0.84694-2.3019z"/></g></g></g></svg>'), i.html('<svg version="1.1" viewBox="0 0 15 14" xmlns="http://www.w3.org/2000/svg"><g fill="#D8A432" fill-rule="evenodd"><g transform="translate(-274 -2606)" fill="#D8A432"><g transform="translate(30 2590)"><path transform="translate(251.26 23) scale(-1) translate(-251.26 -23)" d="m244.28 23.724l5.6 5.9503c0.37947 0.34101 1.1071 0.48178 1.5313 0.0875 0.41776-0.38833 0.40534-1.1415-0.01085-1.5313l-3.9375-4.1783h10.008c0.57988 0 1.05-0.47012 1.05-1.05 0-0.57992-0.47012-1.05-1.05-1.05h-10.008l3.9375-4.1783c0.3583-0.35893 0.42452-1.1386 0.01085-1.5313-0.41356-0.39274-1.1674-0.26726-1.5313 0.087535l-5.6 5.9502c-0.19162 0.20363-0.285 0.44254-0.28438 0.72191 0.0098 0.25025 0.1128 0.53949 0.28438 0.72191z"/></g></g></g></svg>'), e(".yotpo-icon-btn-big.transparent-color-btn.yotpo-visible-mobile").remove(), e('.yotpo-nav-tab[data-type="questions"]').on("click", function() {
                    e(".yotpo-nav-content .yotpo-reviews").attr("style", "display: none!important"), e(".yotpo-nav-content .yotpo-questions").attr("style", "display: block!important"), e(".yotpo-nav-content .write-question-button").attr("style", "display: block!important"), e(".yotpo-form-buttons-wrapper .write-question-button").attr("style", "display: block!important"), e(".yotpo-form-buttons-wrapper .write-review-button").attr("style", "display: none!important")
                }), e('.yotpo-nav-tab[data-type="reviews"]').on("click", function() {
                    e(".yotpo-nav-content .yotpo-reviews").attr("style", "display: block!important"), e(".yotpo-nav-content .yotpo-questions").attr("style", "display: none!important"), e(".yotpo-nav-content .write-question-button").attr("style", "display: none!important"), e(".yotpo-form-buttons-wrapper .write-question-button").attr("style", "display: none!important"), e(".yotpo-form-buttons-wrapper .write-review-button").attr("style", "display: block!important")
                }), s(), e(".yotpo-review").each(function(t, o) {
                    var i = e(o).find(".yotpo-review-stars"),
                        n = e(o).find(".yotpo-main ");
                    i.clone().prependTo(n)
                }), a(), n.data("processed", !0)
            }
        };
    t.init = function() {
        o.window = e(window), o.document = e(document), o.stars = e("[data-js-stars]"), o.reviews = e("[data-js-reviews]"), o.reviewsHeader = e("[data-js-reviews-header]"), o.window.resize(function() {
            s()
        }), new MutationObserver(function(t) {
            var e = !0,
                n = !1,
                a = void 0;
            try {
                for (var s, c = t[Symbol.iterator](); !(e = (s = c.next()).done); e = !0) "childList" === s.value.type && (i = o.stars.find(".text-m")).length && !i.data("processed") && r()
            } catch (t) {
                n = !0, a = t
            } finally {
                try {
                    !e && c.return && c.return()
                } finally {
                    if (n) throw a
                }
            }
        }).observe(o.stars[0], {
            attributes: !1,
            childList: !0,
            subtree: !0
        }), new MutationObserver(function(t) {
            var e = !0,
                i = !1,
                a = void 0;
            try {
                for (var r, s = t[Symbol.iterator](); !(e = (r = s.next()).done); e = !0) "childList" === r.value.type && (n = o.reviews.find(".based-on")).length && !n.data("processed") && c()
            } catch (t) {
                i = !0, a = t
            } finally {
                try {
                    !e && s.return && s.return()
                } finally {
                    if (i) throw a
                }
            }
        }).observe(o.reviews[0], {
            attributes: !1,
            childList: !0,
            subtree: !0
        })
    }
}(window.Reviews = window.Reviews || {}, jQuery),
function(t, e) {
    t.removeIOSRubberEffect = function(t) {
        t.addEventListener("touchstart", function() {
            var e = t.scrollTop,
                o = t.scrollHeight,
                i = e + t.offsetHeight;
            0 === e ? t.scrollTop = 1 : i === o && (t.scrollTop = e - 1)
        })
    };
    t.smooth = function(t) {
        var o = Math.abs(e(window).scrollTop() - t),
            i = Math.round(.3 * o);
        e("html,body").animate({
            scrollTop: t
        }, i)
    }, t.lock = function(t) {
        e("html, body").addClass("no-scroll")
    }, t.unlock = function(t) {
        e("html, body").removeClass("no-scroll")
    }, t.init = function() {
        e(document).on("ontouchmove", function(t) {
            for (var e = !0, o = t.target; null !== o;) {
                if (o.classList && o.classList.contains("disable-scrolling")) {
                    e = !1;
                    break
                }
                o = o.parentNode
            }
            e || t.preventDefault()
        }), e(document).on("click", "[data-scroll]", function() {
            var o = e(this).attr("data-scroll"),
                i = e('[data-scroll-position="' + o + '"]');
            if (i.length) {
                var n = i.offset().top - e("header").outerHeight();
                t.smooth(n)
            } else "top" == o && t.smooth(0)
        })
    }
}(window.Scroll = window.Scroll || {}, jQuery),
function(t, e) {
    var o = {
            slidesToShow: 1,
            slideToScroll: 1,
            dots: !0,
            arrows: !1,
            adaptiveHeight: !0,
            autoplay: !0,
            autoplaySpeed: 5e3,
            customPaging: function(t, e) {
                return '<button class="slick-dot"></button>'
            }
        },
        i = {
            slidesToShow: 4,
            slidesToScroll: 4,
            dots: !1,
            arrows: !0,
            autoplay: !1,
            autoplaySpeed: 5e3,
            prevArrow: '<button class="slick-arrow slick-prev"><i class="fa fa-arrow-left"></i></button>',
            nextArrow: '<button class="slick-arrow slick-next"><i class="fa fa-arrow-right"></i></button>',
            responsive: [{
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            }, {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            }, {
                breakpoint: 540,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }]
        },
        n = {
            slidesToShow: 8,
            slidesToScroll: 1,
            infinite: !1,
            arrows: !1,
            dots: !1,
            vertical: !1,
            focusOnSelect: !0,
            asNavFor: "[product-images]",
            prevArrow: '<button class="slider-control slider-prev" product-thumbnails-control="prev"><i class="fa fa-chevron-left"></i></button>',
            nextArrow: '<button class="slider-control slider-next" product-thumbnails-control="next"><i class="fa fa-chevron-right"></i></button>'
        },
        a = {
            arrows: !0,
            dots: !1,
            mobileFirst: !0,
            focusOnSelect: !0,
            asNavFor: "[product-thumbnails]",
            prevArrow: '<button class="slider-control slider-prev"><i class="fa fa-chevron-left"></i></button>',
            nextArrow: '<button class="slider-control slider-next"><i class="fa fa-chevron-right"></i></button>',
            responsive: [{
                breakpoint: 992,
                settings: {
                    arrows: !1
                }
            }]
        },
        r = {
            slidesToShow: 10,
            slidesToScroll: 1,
            infinite: !0,
            arrows: !1,
            dots: !1,
            prevArrow: '<button class="slider-control slider-prev"><i class="fa fa-arrow-left"></i></button>',
            nextArrow: '<button class="slider-control slider-next"><i class="fa fa-arrow-right"></i></button>',
            responsive: [{
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    arrows: !0
                }
            }]
        },
        s = {
            arrows: !1,
            dots: !1,
            mobileFirst: !0,
            appendArrows: "[brand-collection-nav]",
            prevArrow: '<button class="slider-control slider-prev"><i class="fa fa-chevron-left"></i></button>',
            nextArrow: '<button class="slider-control slider-next"><i class="fa fa-chevron-right"></i></button>',
            responsive: [{
                breakpoint: 560,
                settings: {
                    slidesToShow: 2
                }
            }, {
                breakpoint: 840,
                settings: {
                    slidesToShow: 3
                }
            }, {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    arrows: !0
                }
            }, {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    arrows: !0
                }
            }]
        },
        c = {
            arrows: !1,
            dots: !0,
            mobileFirst: !0,
            prevArrow: '<button class="slider-control slider-prev"><i class="fa fa-chevron-left"></i></button>',
            nextArrow: '<button class="slider-control slider-next"><i class="fa fa-chevron-right"></i></button>',
            responsive: [{
                breakpoint: 560,
                settings: {
                    slidesToShow: 2
                }
            }, {
                breakpoint: 840,
                settings: {
                    slidesToShow: 3
                }
            }, {
                breakpoint: 991,
                settings: {
                    slidesToShow: 4,
                    arrows: !0,
                    dots: !1
                }
            }]
        },
        l = {
            arrows: !1,
            centerMode: !0,
            infinite: !0,
            slidesToScroll: 2,
            touchMove: !1,
            variableWidth: !0
        },
        d = function(t, o) {
            var i = e(t);
            i.length && (window.innerWidth >= 768 && i.slick(o), e(window).on("resize", function() {
                window.innerWidth >= 768 ? i.hasClass("slick-initialized") || i.slick(o) : i.hasClass("slick-initialized") && i.slick("unslick")
            }))
        };
    t.init = function() {
        e(".hero-slider").slick(o), e(".bestsellers-slider").slick(i), e("#addOnSlider").slick(r), e("[product-images]").slick(a), e("[product-thumbnails]").slick(n), e("[brand-collection]").slick(s), e("[products-slider]").slick(c), d(e(".js-image-gallery"), l), e("[product-thumbnails]").on("beforeChange", function(t, o, i, n) {
            n == o.slideCount - o.options.slidesToScroll - 1 ? (e('[product-thumbnails-control="prev"]').removeClass("is-hidden"), e('[product-thumbnails-control="next"]').addClass("is-hidden")) : 0 == n && (e('[product-thumbnails-control="prev"]').addClass("is-hidden"), e('[product-thumbnails-control="next"]').removeClass("is-hidden"))
        })
    }
}(window.Sliders = window.Sliders || {}, jQuery),
function(t, e) {
    var o, n = function(t, n) {
        var a = t,
            r = "https://yotpo-seed-all.herokuapp.com/yotpo-fetch-bottomline?shop=" + o + "&pid=" + a;
        e.get(r).fail(function(t) {
            console.log(t)
        }).done(function(t) {
            avgScore = t.response.bottomline.average_score, totalReviews = t.response.bottomline.total_reviews
        }).always(function(t) {
            avgScoreInt = Math.floor(avgScore);
            var o = '<span class="start-wrap">';
            for (i = 0; i < 4; i++) avgScoreInt <= i ? (avgScoreDec = avgScore % 1, avgScoreDec < .25 ? o += '<span class="yotpo-icon yotpo-icon-empty-star"></span>' : avgScoreDec > .24 && avgScoreDec < .75 ? o += '<span class="yotpo-icon yotpo-icon-star-half"></span>' : avgScoreDec > .74 && (o += '<span class="yotpo-icon yotpo-icon-star"></span>')) : o += '<span class="yotpo-icon yotpo-icon-star"></span>';
            5 === avgScore ? o += '<span class="yotpo-icon yotpo-icon-star"></span>' : avgScore > 3.9 ? (avgScoreDec = avgScore % 1, avgScoreDec < .25 ? o += '<span class="yotpo-icon yotpo-icon-empty-star"></span>' : avgScoreDec > .24 && avgScoreDec < .75 ? o += '<span class="yotpo-icon yotpo-icon-star-half"></span>' : avgScoreDec > .74 && (o += '<span class="yotpo-icon yotpo-icon-star"></span>')) : o += '<span class="yotpo-icon yotpo-icon-empty-star"></span>', o += "</span>", o += !0 === n ? '<span class="total-reviews underline">' + totalReviews + "</span>" : '<span class="total-reviews">(' + totalReviews + ")</span>", e(".no-review-title[data-product-id=" + a + "]").html(o)
        })
    };
    t.init = function(t) {
        o = t, e(".no-review-title").each(function() {
            var t = e(this).data("product-id");
            n(t)
        })
    }
}(window.YotpoStars = window.YotpoStars || {}, jQuery);